module.exports = __webpack_public_path__ + "static/media/011_Bitmap.758fa95a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/011_Bitmap.png
// module id = 390
// module chunks = 0